import DapDSTabGroup from './tab-group.component'

export * from './tab-group.component'
export default DapDSTabGroup

DapDSTabGroup.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-tab-group': DapDSTabGroup
  }
}
